import type { Module } from 'vuex';
import { TranslateEmailTemplate } from '@/types/TranslateEmailTemplate';
import {RootState} from "@/store";

export interface TranslateEmailTemplatesState {
  translateEmailTemplates: TranslateEmailTemplate[];
}

const translateEmailTemplatesModule: Module<TranslateEmailTemplatesState, RootState> = {
  namespaced: true,

  state: (): TranslateEmailTemplatesState => ({
    translateEmailTemplates: [],
  }),

  getters: {
    getById: (state) => (idTranslateEmailTemplate: number): TranslateEmailTemplate | undefined => {
      return state.translateEmailTemplates.find(translateEmailTemplate => translateEmailTemplate.idTranslateEmailTemplate === idTranslateEmailTemplate);
    },
    getByEmailTemplate: (state) => (idEmailTemplate: number): TranslateEmailTemplate[] => {
      return state.translateEmailTemplates.filter(translateEmailTemplate => translateEmailTemplate.idEmailTemplate === idEmailTemplate);
    },
  },

  mutations: {
    setTranslateEmailTemplates(
      state,
      payload: { translateEmailTemplates: Record<number, any> }
    ) {
      state.translateEmailTemplates = Object
        .values(payload.translateEmailTemplates)
        .map(raw => TranslateEmailTemplate.fromRaw(raw));
    },

    setTranslateEmailTemplateCreate(
      state,
      payload: {
        idTranslateEmailTemplate: number;
        idEmailTemplate: number;
        idLanguage: number;
        subject: string;
        body: string;
        bodyHtml: string;
      }
    ) {
      const raw = {
        idTranslateEmailTemplate: payload.idTranslateEmailTemplate,
        idEmailTemplate: payload.idEmailTemplate,
        idLanguage: payload.idLanguage,
        subject: payload.subject,
        body: payload.body,
        bodyHtml: payload.bodyHtml,
        locked: false,
      };
      state.translateEmailTemplates.push(TranslateEmailTemplate.fromRaw(raw));
    },

    setTranslateEmailTemplateUpdate(
      state,
      payload: {
        idTranslateEmailTemplate: number;
        subject?: string;
        body?: string;
        bodyHtml?: string;
      }
    ) {
      const translateEmailTemplate = state.translateEmailTemplates.find(translateEmailTemplate => translateEmailTemplate.idTranslateEmailTemplate === payload.idTranslateEmailTemplate);
      if (!translateEmailTemplate) return;
      if (payload.subject !== undefined) translateEmailTemplate.subject = payload.subject;
      if (payload.body !== undefined) translateEmailTemplate.body = payload.body;
      if (payload.bodyHtml !== undefined) translateEmailTemplate.bodyHtml = payload.bodyHtml;
    },

    setTranslateEmailTemplateDelete(
      state,
      payload: { idTranslateEmailTemplate: number }
    ) {
      state.translateEmailTemplates = state.translateEmailTemplates.filter(
        translateEmailTemplate => translateEmailTemplate.idTranslateEmailTemplate !== payload.idTranslateEmailTemplate
      );
    },

    setTranslateEmailTemplateLock(
      state,
      payload: { idTranslateEmailTemplate: number }
    ) {
      const translateEmailTemplate = state.translateEmailTemplates.find(translateEmailTemplate => translateEmailTemplate.idTranslateEmailTemplate === payload.idTranslateEmailTemplate);
      if (translateEmailTemplate) translateEmailTemplate.locked = true;
    },

    setTranslateEmailTemplateUnlock(
      state,
      payload: { idTranslateEmailTemplate: number }
    ) {
      const translateEmailTemplate = state.translateEmailTemplates.find(translateEmailTemplate => translateEmailTemplate.idTranslateEmailTemplate === payload.idTranslateEmailTemplate);
      if (translateEmailTemplate) translateEmailTemplate.locked = false;
    },
  },

  actions: {
    wsSetTranslateEmailTemplates({ commit }, payload) {
      commit('setTranslateEmailTemplates', payload);
    },
    wsTranslateEmailTemplateCreate({ commit }, payload) {
      commit('setTranslateEmailTemplateCreate', payload);
    },
    wsTranslateEmailTemplateUpdate({ commit }, payload) {
      commit('setTranslateEmailTemplateUpdate', payload);
    },
    wsTranslateEmailTemplateDelete({ commit }, payload) {
      commit('setTranslateEmailTemplateDelete', payload);
    },
    wsTranslateEmailTemplateLock({ commit }, payload) {
      commit('setTranslateEmailTemplateLock', payload);
    },
    wsTranslateEmailTemplateUnlock({ commit }, payload) {
      commit('setTranslateEmailTemplateUnlock', payload);
    },
  },
};

export default translateEmailTemplatesModule;
